var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
export function getPasscode() {
    const match = window.location.search.match(/passcode=(.*)&?/);
    const passcode = match ? match[1] : window.sessionStorage.getItem('passcode');
    return passcode;
}
export function fetchToken(name, room, passcode) {
    return fetch(`/token`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({ user_identity: name, room_name: room, passcode }),
    });
}
export function verifyPasscode(passcode) {
    return fetchToken('temp-name', 'temp-room', passcode).then((res) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const jsonResponse = yield res.json();
        if (res.status === 401) {
            return { isValid: false, error: (_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message };
        }
        if (res.ok && jsonResponse.token) {
            return { isValid: true };
        }
    }));
}
export function getErrorMessage(message) {
    switch (message) {
        case 'passcode incorrect':
            return 'Passcode is incorrect';
        case 'passcode expired':
            return 'Passcode has expired';
        default:
            return message;
    }
}
export default function usePasscodeAuth() {
    const history = useHistory();
    const [user, setUser] = useState(null);
    const [isAuthReady, setIsAuthReady] = useState(false);
    const getToken = useCallback((name, room) => {
        return fetchToken(name, room, user.passcode)
            .then((res) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (res.ok) {
                return res;
            }
            const json = yield res.json();
            const errorMessage = getErrorMessage(((_a = json.error) === null || _a === void 0 ? void 0 : _a.message) || res.statusText);
            throw Error(errorMessage);
        }))
            .then(res => res.json())
            .then(res => res.token);
    }, [user]);
    useEffect(() => {
        const passcode = getPasscode();
        if (passcode) {
            verifyPasscode(passcode)
                .then(verification => {
                if (verification === null || verification === void 0 ? void 0 : verification.isValid) {
                    setUser({ passcode });
                    window.sessionStorage.setItem('passcode', passcode);
                    history.replace(window.location.pathname);
                }
            })
                .then(() => setIsAuthReady(true));
        }
        else {
            setIsAuthReady(true);
        }
    }, [history]);
    const signIn = useCallback((passcode) => {
        return verifyPasscode(passcode).then(verification => {
            if (verification === null || verification === void 0 ? void 0 : verification.isValid) {
                setUser({ passcode });
                window.sessionStorage.setItem('passcode', passcode);
            }
            else {
                throw new Error(getErrorMessage(verification === null || verification === void 0 ? void 0 : verification.error));
            }
        });
    }, []);
    const signOut = useCallback(() => {
        setUser(null);
        window.sessionStorage.removeItem('passcode');
        return Promise.resolve();
    }, []);
    return { user, isAuthReady, getToken, signIn, signOut };
}
//# sourceMappingURL=usePasscodeAuth.js.map